export enum CustomEvents {
  closeActionMenu = 'APG_CLOSE_ACTION_MENU',
  canShareMobile = 'APG_CAN_SHARE_MOBILE',
  uworkAnalyticsSendErrors = 'UWORK_ANALYTICS-SEND-ERRORS',
  uworkAnalyticsSendSucces = 'UWORK_ANALYTICS-SEND-SUCCES',
  dropDownInputSet = 'DROPDOWN_INPUT_SET',
  modalOpen = 'MODAL_OPEN',
  modalClose = 'MODAL_CLOSE',
}
